import React, { useCallback, useEffect, useState } from 'react';

import * as companyService from '../api/companyService';

type CompanyContextProps = {
  company: companyService.Company | null;
  fetch: () => void;
};

const CompanyContext = React.createContext<CompanyContextProps>({
  company: null,
  fetch: () => null,
});

/**
 * CompanyContextProvider provides the company context to it's children
 */
export function CompanyContextProvider({
  children,
  id,
}: React.PropsWithChildren<{ id: string }>) {
  const [company, setCompany] = useState<companyService.Company | null>(null);

  const fetch = useCallback(async () => {
    try {
      const res = await companyService.get(id);

      setCompany(res);
    } catch (e) {
      console.log('error: ', e);
    }
  }, [id]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const ctx = {
    company,
    fetch,
  };

  return (
    <CompanyContext.Provider value={ctx}>{children}</CompanyContext.Provider>
  );
}

export default CompanyContext;
